<template>
	<div class="mx-2 me-2 text-medium">{{ titleCountLabel }}</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

const { t } = useI18n();

const { language } = storeToRefs(useLanguageStore());

const props = withDefaults(
	defineProps<{
		amount?: number;
	}>(),
	{
		amount: 0,
	}
);

const titleCountLabel = computed(() => {
	const integerFormat = new Intl.NumberFormat(language.value);
	const localizedCount = integerFormat.format(props.amount);

	return props.amount === 1
		? t('WEBAPP_TITLE', { NUMBER: localizedCount })
		: t('WEBAPP_TITLES', { NUMBER: localizedCount });
});
</script>
